import React, {useEffect} from 'react';
import {Button, Input, NumberInput, VStack} from '@chakra-ui/react';

import {useForm} from '@/uses/useForm';
import {useApi} from '@/uses/useApi';
import {Field, LanguageField} from '@/components';
import {useLanguage} from '@/contexts/languageContext';

export const CreateOrEditGuideType = (props) => {
    const guideTypeId = props?.id;
    const {getLangObject, availableLanguages, t} = useLanguage();
    const api = useApi();

    const {formData, formFieldErrors, handleInputChange, handleInputChanges, handleFormSubmit} = useForm(
        {
            title: getLangObject(),
            sortOrder: 0,
        },
        {
            title: {
                custom: {
                    function: (value) => Object.values(value).every((v) => v && v.trim().length >= 2),
                    message: t('errors.pleaseFillFieldAllLanguages'),
                },
            },
        }
    );

    /** La ligne de la liste contient déjà toutes les données du type */
    useEffect(() => {
        if (guideTypeId) {
            handleInputChanges({
                title: availableLanguages.reduce((acc, lang) => ({...acc, [lang]: props?.[`${lang}Title`] ?? ''}), {}),
                sortOrder: props?.sortOrder ?? 0,
            });
        }
    }, [guideTypeId]);

    return (
        <VStack h="100%" overflow="hidden" p="1.5rem 0" gap="5vh" w="100%">
            <VStack flex={1} gap="5" p="5" w="100%" align="stretch" justify="flex-start">
                <LanguageField
                    id="title"
                    errors={formFieldErrors.title}
                    label={t('wrappers.mandatoryLabel', {value: t('fields.title')})}
                    renderElement={(lang) => <Input
                        value={formData.title[lang]}
                        onChange={(e) => handleInputChange('title', {...formData.title, [lang]: e?.target?.value ?? ''})}
                        placeholder={t('guides.guideTypeTitle')}
                    />}
                />
                <Field
                    label={t('wrappers.nonMandatoryLabel', {value: t('fields.order')})}
                    errors={formFieldErrors.sortOrder}
                >
                    <NumberInput.Root
                        value={formData.sortOrder}
                        precision={0}
                        step={1}
                        onValueChange={(e) => handleInputChange('sortOrder', Number.isNaN(e.valueAsNumber) ? 0 : e.valueAsNumber)}
                    >
                        <NumberInput.Input/>
                        <NumberInput.Control>
                            <NumberInput.IncrementTrigger/>
                            <NumberInput.DecrementTrigger/>
                        </NumberInput.Control>
                    </NumberInput.Root>
                </Field>
            </VStack>
            <Button
                variant="primary"
                mt="auto"
                height="auto"
                borderRadius=".5rem"
                style={{padding: '1rem 1.5rem'}}
                onClick={() => handleFormSubmit(async (data) => {
                    if (guideTypeId) {
                        return api.ApiService.update('guide_type', guideTypeId, data);
                    }
                    return api.ApiService.create('guide_type', data);
                }, props?.successCallback)}
            >
                {t('actions.validate')}
            </Button>
        </VStack>
    );
};

export default CreateOrEditGuideType;
